<template>
  <div class="d-inline ml-2">
      <span v-if="valid" class="d-inline text-success">
        <strong>HTTPS</strong><i class="icon-checkmark"></i>
      </span>
      <span v-else class="d-inline text-danger">
        <strong>HTTPS</strong><i class="icon-close"></i>
      </span>
  </div>
</template>

<script>
export default {
  props: {
    domain: {
      type: String,
    },
  },
  data() {
    return {
      valid: false,
    };
  },
  created(){
    this.checkHTTPS()
  },
  methods: {
    async checkHTTPS() {
      const response = await fetch('https://'+this.domain);
      if (response.status === 200) {
        this.valid = true;
      } else {
        this.valid = false;
      }
    },
  },
};
</script>
